import { ReactNode } from 'react'
import Header from './Header'
import VoteBanner from '@/components/features/voting/VoteBanner'
import SurveyBanner from '@/components/features/surveys/SurveyBanner'

interface LayoutProps {
  children: ReactNode
}

export default function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      <Header />
      <main className="flex-1 container mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
        <VoteBanner />
        <SurveyBanner />
        {children}
      </main>
      <footer className="border-t py-6 mt-auto">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center text-sm text-muted-foreground">
          <p>&copy; {new Date().getFullYear()} Brent Symphony Orchestra. All rights reserved.</p>
        </div>
      </footer>
    </div>
  )
}
